import { PAYMENT_TYPES } from '../config/constants/payment';
import {
  ERROR_BANK_UNRESPONSIVE,
  ERROR_BILLING_ADDRESS,
  ERROR_CARD_AMEX_DINERS,
  ERROR_CARD_DECLINED,
  ERROR_CARD_DECLINED_BANK,
  ERROR_CARD_DECLINED_DETAILS,
  ERROR_CARD_EXPIRED,
  ERROR_CARD_EXPIRED_NEW_CARD,
  ERROR_CARD_INCORRECT_ADDRESS,
  ERROR_CARD_INCORRECT_CVV,
  ERROR_CARD_INCORRECT_DATE,
  ERROR_CARD_INCORRECT_NUMBER,
  ERROR_CARD_INCORRECT_SECURITY_CODE,
  ERROR_ISSUER_AUTHENTICATION,
  ERROR_PAYPAL_REJECTION,
  PAYPAL_OR_SWITCH,
  POPULATE_CARD_INPUT,
  POPULATE_CARD_OR_SWITCH,
  POPULATE_EMPTY_CARD_OR_SWITCH,
  SAVED_CARD,
} from '../config/text/text';

export const paymentErrorMessageHandler = (errorCode) => {
  switch (errorCode) {
    case 101:
    case 102:
    case 150:
    case 203:
    case 207:
    case 221:
    case 222:
    case 253:
    case 481:
    case 2_046:
    case 2_012:
    case 2_013:
    case 2_014:
    case 2_053:
      return ERROR_CARD_DECLINED_DETAILS;

    case 202:
      return ERROR_CARD_EXPIRED_NEW_CARD;

    case 151:
    case 236:
    case 251:
    case 254:
    case 255:
    case 2_033:
    case 2_034:
    case 2_039:
    case 2_040:
    case 2_042:
    case 3_000:
      return ERROR_BANK_UNRESPONSIVE;

    case 200:
      return ERROR_BILLING_ADDRESS;

    case 201:
    case 204:
    case 208:
    case 210:
    case 241:
    case 476:
    case 2_001:
    case 2_015:
    case 2_057:
    case 2_038:
    case 2_026:
    case 2_002:
    case 2_044:
    case 2_021:
    case 2_061:
    case 2_062:
    case 2_043:
    case 2_051:
    case 2_041:
    case 2_035:
    case 2_027:
    case 2_029:
    case 2_000:
    case 2_003:
    case 2_007:
    case 2_009:
    case 2_019:
    case 2_020:
    case 2_022:
    case 2_101 - 2_999:
      return ERROR_CARD_DECLINED_BANK;

    case 211:
    case 230:
      return ERROR_CARD_INCORRECT_CVV;

    case 223:
    case 387:
    case 2_074:
    case 2_070:
    case 2_086:
    case 2_076:
    case 2_075:
    case 2_059:
    case 2_060:
    case 2_067:
    case 2_071:
    case 2_072:
    case 2_077:
    case 2_093:
    case 2_097:
    case 2_098:
      return ERROR_PAYPAL_REJECTION;

    case 232:
    case 2_024:
    case 81_703:
    case 91_726:
      return ERROR_CARD_AMEX_DINERS;

    case 240:
    case 2_005:
    case 2_008:
    case 81_714:
    case 81_715:
    case 81_716:
    case 81_717:
    case 81_724:
      return ERROR_CARD_INCORRECT_NUMBER;

    case 205:
    case 252:
    case 480:
    case 520:
      return ERROR_CARD_DECLINED_DETAILS;

    case 2_047:
      return ERROR_CARD_DECLINED;

    case 2_004:
      return ERROR_CARD_EXPIRED;

    case 2_006:
    case 81_709:
    case 81_710:
    case 81_711:
    case 81_712:
    case 81_713:
      return ERROR_CARD_INCORRECT_DATE;

    case 2_010:
    case 81_706:
    case 81_707:
    case 81_736:
      return ERROR_CARD_INCORRECT_SECURITY_CODE;

    case 91_744:
      return ERROR_CARD_INCORRECT_ADDRESS;
    default:
      return ERROR_ISSUER_AUTHENTICATION;
  }
};

export const paymentErrorActionHandler = (errorCode) => {
  switch (errorCode) {
    case 150:
    case 203:
    case 252:
    case 481:
    case 520:
    case 2_046:
      return POPULATE_CARD_OR_SWITCH;

    case 223:
    case 387:
    case 2_059:
    case 2_060:
    case 2_067:
    case 2_070:
    case 2_071:
    case 2_072:
    case 2_074:
    case 2_075:
    case 2_076:
    case 2_077:
    case 2_086:
    case 2_093:
    case 2_097:
    case 2_098:
      return PAYPAL_OR_SWITCH;

    case 151:
    case 201:
    case 202:
    case 204:
    case 205:
    case 207:
    case 208:
    case 210:
    case 221:
    case 232:
    case 236:
    case 241:
    case 251:
    case 253:
    case 254:
    case 255:
    case 476:
    case 480:
    case 2_000:
    case 2_001:
    case 2_002:
    case 2_003:
    case 2_004:
    case 2_007:
    case 2_009:
    case 2_012:
    case 2_013:
    case 2_014:
    case 2_015:
    case 2_019:
    case 2_020:
    case 2_021:
    case 2_022:
    case 2_024:
    case 2_026:
    case 2_027:
    case 2_029:
    case 2_033:
    case 2_034:
    case 2_035:
    case 2_038:
    case 2_039:
    case 2_040:
    case 2_041:
    case 2_042:
    case 2_043:
    case 2_044:
    case 2_047:
    case 2_051:
    case 2_053:
    case 2_057:
    case 2_061:
    case 2_062:
    case 2_101 - 2_999:
    case 3_000:
    case 81_703:
    case 91_726:
      return POPULATE_EMPTY_CARD_OR_SWITCH;

    case 211:
    case 2_010:
    case 81_706:
    case 81_707:
      return SAVED_CARD;

    case 101:
    case 102:
    case 200:
    case 222:
    case 230:
    case 240:
    case 2_005:
    case 2_006:
    case 2_008:
    case 81_709:
    case 81_710:
    case 81_711:
    case 81_712:
    case 81_713:
    case 81_714:
    case 81_715:
    case 81_716:
    case 81_717:
    case 81_724:
    case 81_736:
    case 91_744:
      return POPULATE_CARD_INPUT;
    default:
      return null;
  }
};

export const paymentActionTypeHandler = ({
  type,
  action,
  savedCard,
  paypalToken,
}) => {
  if (
    action === PAYPAL_OR_SWITCH &&
    type === PAYMENT_TYPES.paypal &&
    savedCard
  ) {
    return { emptyForm: null, type: PAYMENT_TYPES.card };
  }
  if (
    (action === POPULATE_CARD_OR_SWITCH ||
      action === POPULATE_EMPTY_CARD_OR_SWITCH) &&
    paypalToken
  ) {
    return { emptyForm: null, type: PAYMENT_TYPES.paypal };
  }
  if (action === POPULATE_EMPTY_CARD_OR_SWITCH && !paypalToken) {
    return { emptyForm: true, type: PAYMENT_TYPES.card };
  }
  if (action === POPULATE_CARD_INPUT || action === SAVED_CARD) {
    return { emptyForm: null, type: null }; // left here in case the otucome of these scenarios changes in the futture
  }

  return { emptyForm: null, type: null };
};
